import { render, staticRenderFns } from "./S1_P1_Studios.vue?vue&type=template&id=f6a05d94&scoped=true&"
import script from "./S1_P1_Studios.vue?vue&type=script&lang=js&"
export * from "./S1_P1_Studios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a05d94",
  null
  
)

export default component.exports